import { Component, Input } from '@angular/core';
import { GenericService } from "../../../services/generic.service";

@Component({
  selector: 'generic-comp',
  templateUrl: './template-generic.html'
})

export class GenericComponent {
  public compData: any;
  @Input() set initData(value: any) {
    this.compData = value;
  }
  constructor(public _genericService: GenericService){
  }
}